import { useMutation, useQueryClient } from 'react-query';
import { updateBillingDetails } from 'api/services/payments';
import usePaymentsStore from '../store/paymentStore';

const useUpdateBillingDetails = (onSuccess) => {
  const queryClient = useQueryClient();
  const setPaymentMethod = usePaymentsStore((state) => state.setPaymentMethod);

  const { mutate } = useMutation({
    mutationFn: async (data) => {
      await updateBillingDetails(data);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['paymentMethod'] });
      setPaymentMethod();
      onSuccess();
    },
  });

  return {
    mutate,
  };
};

export default useUpdateBillingDetails;
